import {styled} from '@linaria/react';
import React from 'react';
import {COLORS} from '../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';

interface SectionHeadlineProps {
  label?: string;
  dataTestId?: string;
  className?: string;
}

export const SectionHeadline: React.FC<SectionHeadlineProps> = ({
  label,
  dataTestId = 'sectionHeadline',
  className,
}) => {
  return (
    <Wrapper className={className} data-testid={dataTestId}>
      {label}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  color: ${COLORS.Grey1};
  font-size: ${FONT_SIZES.px10};
  font-weight: ${FONT_WEIGHTS.w700};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-height: 36px;
`;
